__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-travel-home'].baseUrl;
import ModuleContainer from './components/TravelHomeWrapper';
import homeReducer from './ducks/homeDuck';
import { MODULE_NAME } from './constants/modules';
import { loadModuleData } from './thunks/loadModuleData';

// istanbul ignore next
ModuleContainer.holocron = {
  name: MODULE_NAME,
  reducer: homeReducer,
  loadModuleData
};
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    requiredExternals: {
      '@americanexpress/fetchye-amex': '^0.13.0',
      '@americanexpress/data-manager-utils': '^0.4.2',
      '@americanexpress/one-app-module-wrapper': '^3.4.4',
      '@americanexpress/one-experiments': '^2.1.3',
      '@americanexpress/react-seo': '^2.2.1',
      '@americanexpress/conditional-features': '^3.4.0',
      '@americanexpress/react-ddl': '^0.3.5',
      '@americanexpress/reactlytics': '^1.2.6',
      '@americanexpress/travel-selectors': '^5.0.0',
      'iguazu': '^3.2.0',
      'iguazu-rest': '^1.8.0',
      'react-intl': '^6.5.5',
      'xss': '^1.0.15',
      'fetchye-one-app': '^1.6.0'
    }
  });
}